import { useEffect, useSyncExternalStore } from "react";
import { loadConnectionSettings } from "../services/connectionSettingsApi";
import { publishCompetitorTracking, readCompetitorTracking, subscribeCompetitorTracking } from "../services/competitorTracking";

/** Every property and version a read was started for, kept for the page load: once each, shared while in flight. */
const startedReads = new Set<string>();

export function forgetCompetitorTrackingReadsForTests(): void {
    startedReads.clear();
}

function startRead(key: string): void {
    if (startedReads.has(key)) return;
    startedReads.add(key);
    loadConnectionSettings()
        .then(({ settings, connectionId }) => {
            // Filed under the property the server answered for: the one open now may not be the one asked about.
            if (connectionId !== undefined) publishCompetitorTracking(connectionId, settings?.compsetEnabled === true);
        })
        .catch(() => {});
}

/**
 * Whether the property tracks its competitors, off until known. With `read`, an unknown value is read from the
 * settings, once per property and version.
 */
export function useCompetitorTracking(
    connectionId: number | null | undefined,
    connectionVersion: number,
    { read }: { read: boolean },
): boolean {
    const known = useSyncExternalStore(
        subscribeCompetitorTracking,
        () => (connectionId == null ? undefined : readCompetitorTracking(connectionId)),
    );

    const unknown = known === undefined;
    useEffect(() => {
        if (!read || connectionId == null || !unknown) return;
        startRead(`${connectionId}:${connectionVersion}`);
    }, [read, connectionId, connectionVersion, unknown]);

    return known === true;
}
